import axios from 'axios';

export function getCustomClient(school) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/customClients/', {
          params: {
            school,
          },
        })
        .then((response) => {
          const data = response.data.client;

          return resolve(data);
        })
        .catch((error) => {
          console.log('Error while getting custom client', error);

          return resolve();
        });
    });
  };
}
